import { z } from "zod";

import { ERROR_TYPE } from "@/utils";
import { TokenPurpose, TokenStatus } from "@/enum";

import { FetchMeResponseSchema } from "../../Login/schema/login";

const { REQUIRED } = ERROR_TYPE;

export const SetPasswordSchema = z.object({
	password: z.string().min(1, { message: REQUIRED }).trim(),
});

export const SetPasswordRequestSchema = z.object({
	password: z.string().min(8),

	token: z.string().min(1, { message: REQUIRED }),
	purpose: z.nativeEnum(TokenPurpose),
});

export const SetPasswordResponseSchema = z.object({
	status: z.nativeEnum(TokenStatus),
	email: z.string().email().optional(),
	user: FetchMeResponseSchema.optional(),
	accessToken: z.string().optional(),
	refreshToken: z.string().optional(),
	otpToken: z.string().optional(),
});

export type SetPasswordType = z.infer<typeof SetPasswordSchema>;
export type SetPasswordBody = z.infer<typeof SetPasswordRequestSchema>;
export type SetPasswordResponse = z.infer<typeof SetPasswordResponseSchema>;
